
<template>
  <div class="container">
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div
      class="image"
      v-for="(image, imageIndex) in images"
      :key="imageIndex"
      @click="index = imageIndex"
      :style="{ backgroundImage: 'url(' + image + ')', width: '440px', height: '350px' }"
    ></div>
  </div>
</template>

<style scoped>
  .image {
    float: left;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin: 5px;
  }
</style>

<script>
import API from '@aws-amplify/api';
// import axios from 'axios';
import VueGallery from 'vue-gallery'; 

API.configure();

export default {
  name: 'Images',
  components: {
    'gallery': VueGallery
  },
  data:  () => {
    return {      
      jobNumber: '',
      month: '',
      year: '',
      images: [
      ],
      index: null
    };
  },
  created() {
    this.getImages();
  },
  watch: {
    $route () {
      this.images = [];
      this.getImages();
    }
  },
  methods: {
    reload: function() {
      location.reload();
    },
    getImages: function() {
      this.jobNumber = this.$route.query.jobNumber;
      this.year = this.$route.query.year;
      this.month = this.$route.query.month;

      const apiName = 'mprAPI';
      const path = '/images';
      const request = {
        'queryStringParameters': {
          'jobNumber': this.jobNumber,
          'year': this.year,
          'month': this.month
        }
      };

      API
        .get(apiName, path, request)
        .then(response => {
          this.images = response;
        })
        .catch(() => {
        });
    }
  }
}
</script>
